export const WORKING_STATUS = ['calling', 'talking', 'wraptime'];
